import React from 'react';
import {FIND_ALL_INSTALADOR as query} from '../../graphql/queries';
import {SelectBase} from './mui-base';

const getVariables = ({pageNumber, search = '', pageSize = 20}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'nome', sortDir: 'ASC'},
    searchDTO: {search, ativo: true},
  };
};

export const SelectInstaladores = (props) => {
  return (
    <SelectBase
      label="Instalador"
      responseObjectName="findAllInstalador"
      labelProp="nome"
      query={query}
      getVariables={getVariables}
      {...props}
    />
  );
};